/**
 * richTextHtml — the single reading of a rich-text value.
 *
 * A rich-text field travels in three shapes depending on where it comes from:
 * a plain HTML string (legacy / freshly typed), `{processed}` (the decoupled
 * formatter's filter-chain output) or `{value}` (raw HTML, seen between an
 * inline edit and the next backend round-trip). Both renderers of rich text —
 * `BuilderHtmlField` (a whole field) and `BuilderRowField` (a list cell) —
 * read it through here so they never diverge.
 *
 * @param {unknown} evaluated The already-evaluated store value.
 * @returns {string} HTML, or '' when there is nothing to render.
 */
export const resolveRichTextHtml = (evaluated) => {
  if (typeof evaluated === 'string') return evaluated
  if (evaluated && typeof evaluated === 'object') {
    if (typeof evaluated.processed === 'string') return evaluated.processed
    if (typeof evaluated.value === 'string') return evaluated.value
  }
  return ''
}

export default resolveRichTextHtml
